export enum fraudAndRiskLevel {
  low,
  medium,
  high,
}
